import React from "react";

export default React.memo(function UserIconSvg() {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.0006 12C21.2404 12 18.1909 15.0471 18.1899 18.8076L18.1899 18.8095L18.1899 18.8057L18.1899 18.8076C18.1782 22.5569 21.2078 25.6074 24.9566 25.6201L24.9604 25.6201H25.0006C28.7619 25.6201 31.81 22.5702 31.81 18.8095C31.81 15.0485 28.7616 12 25.0006 12ZM20.4204 18.8095C20.4204 16.2806 22.4711 14.2305 25.0006 14.2305C27.5297 14.2305 29.5795 16.2803 29.5795 18.8095C29.5795 21.339 27.5294 23.3897 25.0006 23.3897H24.9626C22.4462 23.3802 20.4118 21.3315 20.4204 18.8132L20.4204 18.8095Z"
                fill="#3B85F7"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.0006 27.5288C22.5807 27.5288 20.2081 27.7076 18.4062 28.3117C17.4996 28.6157 16.6547 29.0539 16.0264 29.706C15.3717 30.3856 15 31.2508 15 32.2707C15 33.2882 15.3683 34.1535 16.0191 34.8356C16.6442 35.4907 17.4861 35.9331 18.392 36.2411C20.192 36.853 22.5659 37.0385 25.0006 37.0385C27.4206 37.0385 29.793 36.8594 31.5946 36.2551C32.501 35.951 33.3457 35.5128 33.9738 34.8607C34.6283 34.1812 35 33.3162 35 32.2966C35 31.2793 34.6318 30.4142 33.9811 29.7323C33.3561 29.0772 32.5144 28.6347 31.6087 28.3267C29.809 27.7146 27.4354 27.5288 25.0006 27.5288ZM17.2305 32.2707C17.2305 31.8396 17.3703 31.5259 17.6328 31.2535C17.9217 30.9536 18.3995 30.6665 19.1152 30.4265C20.5579 29.9428 22.6279 29.7593 25.0006 29.7593C27.3843 29.7593 29.4528 29.9494 30.8905 30.4384C31.6035 30.6809 32.0794 30.9702 32.3673 31.272C32.6296 31.5468 32.7695 31.8634 32.7695 32.2966C32.7695 32.7274 32.6297 33.0409 32.3673 33.3134C32.0785 33.6132 31.6008 33.9004 30.8852 34.1404C29.4429 34.6242 27.3732 34.808 25.0006 34.808C22.6168 34.808 20.5479 34.6182 19.1099 34.1293C18.3968 33.8869 17.9208 33.5976 17.6328 33.2958C17.3705 33.0209 17.2305 32.7042 17.2305 32.2707Z"
                fill="#3B85F7"
            />
        </svg>
    );
});